<ca-dropdown-submenu *ngIf="isRenameBtnEnabled || isDeleteBtnEnabled" data-uit="file-submenu" (openChange)="openChange.emit($event)">
    <button *ngIf="isRenameBtnEnabled" data-uit="folder-rename-btn" type="button" class="dropdown-item" (click)="onRename()">
        <ca-icon name="pen" size="s"></ca-icon>
        {{ 'GENERAL.RENAME' | translate }}
    </button>
    <button *ngIf="isShareBtnEnabled" data-uit="file-share-btn" type="button" class="dropdown-item" (click)="onShare()">
        <ca-icon name="share" size="s"></ca-icon>
        {{ 'GENERAL.SHARE' | translate }}
    </button>
    <button *ngIf="isDeleteBtnEnabled" data-uit="folder-delete-btn" type="button" class="dropdown-item" (click)="onDelete()">
        <ca-icon name="trash" size="s"></ca-icon>
        {{ 'GENERAL.DELETE' | translate }}
    </button>
</ca-dropdown-submenu>
